module.exports = __webpack_public_path__ + "img/187.e79e2f1b.jpg";